<template lang="html">
  <div v-if="isHide !== '1' && showBool" class="float-bar" :class="[position === 'bottom' ? 'bottom' : 'top']">
    <span class="icon"></span>
    <span class="text">快乐一点就来</span>
    <button class="btn" @click="goDownload()"></button>
  </div>
</template>

<script>
  import API from "../../api/api";
  import utils from "../../api/utils";

  export default {
    name: 'home-header',
    props: {
      position: {
        type: String,
        default: 'top'
      },
      show: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        channel: '',
        isHide: '',
        showBool: this.show
      }
    },
    watch: {
      show () {
        this.showBool = this.show
      }
    },
    created () {
      this.channel = MG.utils.getQueryString('channel') ? MG.utils.getQueryString('channel') : ''
      this.isHide = MG.utils.getQueryString('isHide') ? MG.utils.getQueryString('isHide') : ''
    },
    mounted () {
      this.getTouchDirec();
    },
    methods: {
      goDownload () {
        utils.pullGame()
      },
      getTouchDirec () {
        var startx;
        var starty;

        //手指接触屏幕
        document.addEventListener("touchstart", (e) => {
          startx = e.touches[0].pageX;
          starty = e.touches[0].pageY;
        }, false);

        //手指离开屏幕
        document.addEventListener("touchend", (e) => {
          var endx = e.changedTouches[0].pageX;
          var endy = e.changedTouches[0].pageY;
          if (endx - startx > 50 || endx - startx < -50) {
            if (endy - starty < 60 && endy - starty > -60) {
              return
            }
          }
          if (endy - starty < 0) {
            this.showBool = false
          } else {
            this.showBool = true
          }
        }, false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .float-bar {
    width: 100%;
    height: 1.47rem;
    position: fixed;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 20;
    .icon {
      margin: 0.267rem 0rem 0.266rem 0.267rem;
      display: inline-block;
      width: 0.96rem;
      height: 0.96rem;
      background: url('./../../assets/miguplay/images/v1/home-head-logo.png') no-repeat center center; 
      background-size: 100%;
      margin: auto;
      position: absolute;
      left: 0.4rem;
      top: 0;
      bottom: 0;
    }
    .text {
      width: fit-content;
      height: 0.48rem;
      font-family: PingFangSC-Semibold;
      font-size: 0.347rem;
      color: #ffffff;
      letter-spacing: 0.00427rem;
      text-align: left;
      line-height: 0.48rem;
      margin: auto;
      position: absolute;
      left: 1.6rem;
      top: 0;
      bottom: 0;
    }
    .btn {
      outline: none;
      border: none;
      display: inline-block;
      width: 2.08rem;
      height: .69rem;
      background: url('./../../assets/miguplay/images/v1/btn-download.png') no-repeat center center; 
      background-size: 100%;
      margin: auto;
      position: absolute;
      right: .4rem;
      top: 0;
      bottom: 0;
    }
  }

  .bottom {
    bottom: 0;
  }
  .top {
    top: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/homeCompents/homeHeader.vue